module.exports = __webpack_public_path__ + "static/img/dxgc_2@2x.a1b2fb5e.png";